import React from 'react';

// --- IMPORT DOS VÍDEOS (Certifique-se que os arquivos existem em src/assets) ---
import video1 from '../assets/depoimento1.mp4';
import video2 from '../assets/depoimento2.mp4';
import video3 from '../assets/depoimento3.mp4';
import video4 from '../assets/depoimento4.mp4';
import video5 from '../assets/depoimento5.mp4';
import video6 from '../assets/depoimento6.mp4';
import video7 from '../assets/depoimento7.mp4';

// --- IMPORT DAS CAPAS (Você precisa salvar os prints na pasta src/assets com esses nomes) ---
import thumb1 from '../assets/thumb1.jpg';
import thumb2 from '../assets/thumb2.jpg';
import thumb3 from '../assets/thumb3.jpg';
import thumb4 from '../assets/thumb4.jpg';
import thumb5 from '../assets/thumb5.jpg';
import thumb6 from '../assets/thumb6.jpg';
import thumb7 from '../assets/thumb7.jpg';

const Depoimentos = () => {
  
  // Relaciona cada vídeo com sua respectiva capa (Poster)
  const depoimentosData = [
    { video: video1, poster: thumb1 },
    { video: video2, poster: thumb2 },
    { video: video3, poster: thumb3 },
    { video: video4, poster: thumb4 },
    { video: video5, poster: thumb5 },
    { video: video6, poster: thumb6 },
    { video: video7, poster: thumb7 },
  ];

  // Função para rolar até a seção de ofertas
  const scrollToOfertas = () => {
    const element = document.getElementById('ofertas');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section style={styles.section}>
      <div className="container" style={styles.container}>
        
        <h2 style={styles.title}>QUEM USA, AMA! 💜</h2>
        <p style={styles.subtitle}>
          Veja o que os tutores estão falando sobre a transformação:
        </p>

        {/* CONTAINER DE SCROLL HORIZONTAL */}
        <div style={styles.scrollContainer}>
          {depoimentosData.map((item, index) => (
            <div key={index} style={styles.videoCard}>
              <div style={styles.videoWrapper}>
                <video 
                  src={item.video}     // O vídeo
                  poster={item.poster} // A MÁGICA: A foto de capa aparece antes do play
                  controls 
                  playsInline          // Essencial para iPhone
                  preload="metadata"   // Carrega só o básico para economizar dados
                  style={styles.video}
                />
              </div>
              <div style={styles.cardFooter}>
                <span style={styles.stars}>⭐⭐⭐⭐⭐</span>
                <p style={styles.verified}>Compra Verificada</p>
              </div>
            </div>
          ))}
        </div>

        <p style={styles.dragHint}>
            👈 Arraste para o lado para ver mais 👉
        </p>

        {/* BOTÃO DE AÇÃO */}
        <div style={styles.buttonWrapper}>
          <button onClick={scrollToOfertas} style={styles.ctaButton}>
            QUERO GARANTIR ESSES RESULTADOS ➔
          </button>
        </div>

      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 0', 
    backgroundColor: '#FFF8F0', 
    textAlign: 'center'
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px'
  },
  title: {
    color: '#513D8B',
    fontSize: '2.5rem',
    marginBottom: '10px',
    textTransform: 'uppercase'
  },
  subtitle: {
    color: '#666',
    marginBottom: '40px',
    fontFamily: '"Commissioner", sans-serif',
    fontSize: '1.1rem'
  },
  
  // --- CARROSSEL / SCROLL ---
  scrollContainer: {
    display: 'flex',
    gap: '20px',
    overflowX: 'auto', 
    paddingBottom: '30px',
    paddingLeft: '20px', 
    paddingRight: '20px',
    scrollSnapType: 'x mandatory', 
    WebkitOverflowScrolling: 'touch', 
    justifyContent: 'flex-start' 
  },
  videoCard: {
    flex: '0 0 auto', 
    width: '280px',   
    backgroundColor: '#fff',
    borderRadius: '20px',
    padding: '10px',
    boxShadow: '0 8px 0px #e0e0e0', 
    border: '2px solid #eee',
    scrollSnapAlign: 'center' 
  },
  videoWrapper: {
    width: '100%',
    height: '400px', 
    backgroundColor: '#000', // Fundo preto caso a imagem demore 1ms pra carregar
    borderRadius: '15px',
    overflow: 'hidden',
    marginBottom: '10px',
    position: 'relative'
  },
  video: {
    width: '100%',
    height: '100%',
    objectFit: 'cover' // Garante que a capa preencha tudo sem esticar
  },
  cardFooter: {
    textAlign: 'left',
    padding: '0 5px'
  },
  stars: {
    display: 'block',
    fontSize: '0.9rem',
    marginBottom: '5px'
  },
  verified: {
    color: '#397449', 
    fontSize: '0.8rem',
    fontWeight: 'bold',
    fontFamily: '"Commissioner", sans-serif',
    textTransform: 'uppercase'
  },
  dragHint: {
    marginTop: '10px',
    marginBottom: '40px', 
    color: '#999',
    fontSize: '0.9rem',
    fontFamily: '"Commissioner", sans-serif'
  },

  // --- BOTÃO ---
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px'
  },
  ctaButton: {
    backgroundColor: '#32CD32', 
    color: '#fff',
    border: 'none',
    padding: '18px 40px',
    borderRadius: '50px',
    fontSize: '1.1rem',
    fontWeight: '900',
    cursor: 'pointer',
    fontFamily: '"Commissioner", sans-serif',
    boxShadow: '0 6px 0px #228B22', 
    textTransform: 'uppercase',
    transition: 'transform 0.2s, box-shadow 0.2s',
    maxWidth: '90%',
    width: 'auto'
  }
};

export default Depoimentos;